import { css } from '@emotion/react';
import { Box, BoxProps } from 'components/box';
import { ReactNode } from 'react';

const LinearGradientBorder = ({
  to,
  children,
  startColor,
  middleColor,
  endColor,
  borderRadius = 2,
  borderWidth = '1px',
  innerBackgroundColor = 'white',
}: {
  to: 'bottom' | 'top' | 'left' | 'right';
  children: ReactNode;
  startColor: string;
  middleColor?: string;
  endColor: string;
  borderRadius?: BoxProps['borderRadius'];
  borderWidth?: BoxProps['borderWidth'];
  innerBackgroundColor?: BoxProps['backgroundColor'];
}) => (
  <Box
    padding={borderWidth}
    borderRadius={borderRadius}
    css={css`
      background: linear-gradient(
        to ${to},
        ${startColor},
        ${middleColor ? `${middleColor},` : ''} ${endColor}
      );
    `}
  >
    <Box
      borderRadius={borderRadius}
      backgroundColor={innerBackgroundColor}
      width="100%"
    >
      {children}
    </Box>
  </Box>
);

export default LinearGradientBorder;
